
import { Component, Vue, Watch } from 'vue-property-decorator'

interface Form {
  realName: string
  certificationType: string
  certificationNumber: string
  certification: string[]
}

@Component
export default class PersonCertificate extends Vue {
  validateImg = async (rule: any, val: Array<any>, callback: (arg0?: Error | undefined) => void) => {
    // eslint-disable-next-line no-magic-numbers
    if (val.length === 2) {
      callback()
    } else {
      callback(new Error('请上传身份证正反面图片各一张'))
    }
  }

  validateName = async (rule: any, val: any, callback: (arg0?: Error | undefined) => void) => {
    if (this.form.certificationType === 'SPECIALPASS' || this.form.certificationType === 'TAIWANPASS') {
      callback()
    } else if (!/^[\u4e00-\u9fa5]+$/.test(`${val}`)) {
      callback(new Error('只支持中文，请重新填写'))
      // eslint-disable-next-line no-magic-numbers
    } else if (val.length < 2 || val.length > 20) {
      callback(new Error('字符长度为2-20个字符，请重新填写'))
    } else {
      callback()
    }
  }

  validateIdNumber = async (rule: any, val: any, callback: (arg0?: Error | undefined) => void) => {
    if (this.form.certificationType === 'SPECIALPASS' || this.form.certificationType === 'TAIWANPASS') {
      callback()
      // eslint-disable-next-line no-magic-numbers
    } else if (val.length !== 18) {
      callback(new Error('请正确填写证件号码'))
    } else {
      callback()
    }
  }

  $refs!: {
    form: HTMLFormElement
  }

  form: Form = {
    realName: '',
    certificationType: 'IDENTITYCARD',
    certificationNumber: '',
    certification: [],
  }

  idTypeOptions = [
    { label: '身份证', value: 'IDENTITYCARD' },
    { label: '港澳居民来往内地通行证', value: 'SPECIALPASS' },
    { label: '台湾居民来往大陆通行证', value: 'TAIWANPASS' },
  ]

  fileList: UploadFileDetail[] = []

  rules = {
    realName: [
      { required: true, message: '真实姓名不能为空', trigger: 'blur' },
      { validator: this.validateName, trigger: 'blur' },
    ],
    certification: [
      { required: true, message: '请上传身份证正反面图片各一张', trigger: 'blur' },
      { validator: this.validateImg, trigger: 'blur' },
    ],
    certificationType: [{ required: true, message: '证件类型不能为空', trigger: 'change' }],
    certificationNumber: [
      { required: true, message: '证件号码不能为空', trigger: 'blur' },
      { validator: this.validateIdNumber, trigger: 'blur' },
    ],
  }

  // eslint-disable-next-line no-magic-numbers
  limit = 2

  get hideUploadBtn() {
    return this.form.certification.length >= this.limit
  }

  handleRemove(file: UploadFileDetail) {
    this.fileList = this.fileList.filter((o) => o.uid !== file.uid)
  }

  async handleChangeUpload(file: UploadFileDetail, fileList: UploadFileDetail[]) {
    this.$refs.form.clearValidate('certification')
    const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
    if (fileType !== 'jpg' && fileType !== 'png' && fileType !== 'jpeg') {
      this.$dsMessage.error('只支持jpg、png、jpeg格式，请重新上传')
      fileList.splice(-1, 1)
      return
    }
    // eslint-disable-next-line no-magic-numbers
    const imgSize = Number(file.size / 1024 / 1024)
    // eslint-disable-next-line no-magic-numbers
    if (imgSize > 3) {
      this.$dsMessage.error('文件大小不能超过3M，请重新上传')
      fileList.splice(-1, 1)
      return
    }
    this.getBase64(file.raw).then((res: any) => {
      file.base64 = res
      this.fileList.push(file)
    })
  }

  getBase64(file: UploadRawFile) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      let imgResult: string | ArrayBuffer | null
      reader.readAsDataURL(file)
      reader.onload = () => {
        imgResult = reader.result
      }
      reader.onerror = (error) => {
        reject(error)
      }
      reader.onloadend = () => {
        resolve(imgResult)
      }
    })
  }

  onSubmit() {
    this.$refs.form.validate(async (valid: boolean) => {
      if (valid) {
        try {
          await this.$ucProxy({
            url: '/api/v1/account/certification',
            type: 'POST',
            data: JSON.stringify({
              ...this.form,
              certification: JSON.stringify(this.form.certification),
            }),
            contentType: 'application/json;charset=UTF-8',
          })
          this.$router.push({ name: 'CertificateSuccess', query: this.$route.query })
        } catch (err) {
          const typedError = err as AxiosError
          this.$dsMessage.error(typedError.responseJSON.message)
        }
      }
    })
  }

  handleChangeType() {
    this.$refs.form.validateField(['realName', 'certificationNumber'])
  }

  @Watch('fileList')
  onVisibleChange(val: UploadFileDetail[]) {
    this.form.certification = val.map((o: UploadFileDetail) => o.base64 || '')
  }
}
